import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { css } from "styled-components";
const Wrapper = styled.div`
  display: grid;
  grid-gap: ${_ref => {
  let {
    $gap,
    theme
  } = _ref;
  return $gap * theme.typography.fontStep;
}}rem;
  align-items: ${_ref2 => {
  let {
    $align
  } = _ref2;
  return $align;
}};
  justify-items: ${_ref3 => {
  let {
    $justify
  } = _ref3;
  return $justify;
}};
  justify-content: ${_ref4 => {
  let {
    $justify
  } = _ref4;
  return $justify;
}};
  ${_ref5 => {
  let {
    $fullWidth
  } = _ref5;
  return $fullWidth && "width: 100%";
}};
  ${_ref6 => {
  let {
    $fullHeight
  } = _ref6;
  return $fullHeight && "height: 100%";
}};
  ${_ref7 => {
  let {
    $template,
    $cols,
    $equal
  } = _ref7;
  return $template ? css`
          grid-template-columns: ${$template};
        ` : css`
          grid-template-columns: repeat(${$cols}, minmax(0, ${$equal ? "1fr" : "auto"}));
        `;
}};
  ${_ref8 => {
  let {
    $s,
    theme
  } = _ref8;
  return theme.spacing.resolve(theme, $s);
}};
`;
const Cell = styled.div`
  align-self: ${_ref9 => {
  let {
    $align
  } = _ref9;
  return $align;
}};
  justify-self: ${_ref10 => {
  let {
    $justify
  } = _ref10;
  return $justify;
}};
  ${_ref11 => {
  let {
    $s,
    theme
  } = _ref11;
  return theme.spacing.resolve(theme, $s);
}};
  ${_ref12 => {
  let {
    $area
  } = _ref12;
  return $area && `grid-area:${$area}`;
}};
  ${_ref13 => {
  let {
    $colSpan
  } = _ref13;
  return $colSpan && `grid-column: span ${$colSpan}`;
}};
  ${_ref14 => {
  let {
    $rowSpan
  } = _ref14;
  return $rowSpan && `grid-row: span ${$rowSpan}`;
}};
  ${_ref15 => {
  let {
    $align
  } = _ref15;
  return $align === "center" && `
  & > * {
    vertical-align: middle;
  }
  `;
}};
`;
const Grid = _ref16 => {
  let {
    cols,
    gap = 0,
    equal = false,
    align = "start",
    justify = "stretch",
    template,
    fullWidth = false,
    fullHeight = false,
    children,
    s,
    ...rest
  } = _ref16;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $cols: cols,
    $gap: gap,
    $equal: equal,
    $align: align,
    $justify: justify,
    $fullWidth: fullWidth,
    $fullHeight: fullHeight,
    $template: template,
    $s: s
  }, rest), children);
};
Grid.Cell = _ref17 => {
  let {
    align = "start",
    justify = "stretch",
    area,
    s,
    colSpan,
    rowSpan,
    children,
    ...rest
  } = _ref17;
  return /*#__PURE__*/React.createElement(Cell, _extends({
    $align: align,
    $justify: justify,
    $area: area,
    $s: s,
    $colSpan: colSpan,
    $rowSpan: rowSpan
  }, rest), children);
};
export default Grid;